<div class="fn-search-input">
    <div class="fn-search-input__label">
        {{ "IP.SEARCH.SEARCH_DEFAULT" | translate }}
    </div>
    <div class="fn-search-input__container">
        <input
            type="text"
            class="fn-search-input__container-input"
            [(ngModel)]="this.searchValue"
        />
        <button
            class="fn-search-input__container-search-btn"
            (click)="this.onSearch.emit(this.searchValue)"
        >
            <img
                src="../../../../assets/new-styles/icons/buttons/search-icon-white.svg"
                alt="Search icon"
            />
        </button>
    </div>
</div>
